let resumeData = {
    "imagebaseurl":"https://rahulmranga.github.io/",
    "name": "Rahul Rangarao",
    "role": "Data Scientist",
    "linkedinId":"https://www.linkedin.com/in/rahul-mohan",
    "roleDescription": "with over 3 years of experience currently enrolled in a Masters program at UT Austin. I've had extensive experience working with fortune 100 clients across multiple domains to deliver impactful data solutions. Passionate about solving problems, I am keen on collaborating with stakeholders, to identify challenge statements and look at solutions from a holistic business point of view",
    "socialLinks":[
        {
          "name":"linkedin",
          "url":"https://www.linkedin.com/in/rahul-mohan",
          "className":"fa fa-linkedin"
        },
        {
          "name":"github",
          "url":"https://github.com/rahulmr96",
          "className":"fa fa-github"
        }
      ],
    "aboutme":"I am currently enrolled in a MS in Information Technology Management at UT Austin and will be graduating in May 2023. I have had extensive experience working with fortune 100 clients across multiple domains delivery impactful data solutions",
    "address":"Austin Texas",
    "website":"https://rahulmranga.github.io",
    "education":[
      {
        "UniversityName":"University of Texas at Austin",
        "specialization":"M.S in Information Technology Mangement",
        "MonthStart":'Jun',
        "YearStart":'2022',
        "MonthOfPassing":"May",
        "YearOfPassing":"2023"
      },
      {
        "UniversityName":"Sri Jayachamarajendra College of Engineering",
        "specialization":"B.E in Electronics and Communication",
        "MonthStart":'Aug',
        "YearStart":'2014',
        "MonthOfPassing":"May",
        "YearOfPassing":"2018"
      }
    ],
    "work":[
      {
        "CompanyName":"Kore Wireless (Capstone project with UT Austin)",
        "specialization":"Sr Developer",
        "MonthStart":'Jan',
        "YearStart":'2023',
        "MonthOfLeaving":"May",
        "YearOfLeaving":"2023",
        "Achievements":"Lead developer working on identifying risks associated with external factors that affect IoT device network latency"
      },      
      {
        "CompanyName":"Mu Sigma Business Solutions",
        "specialization":"Sr Data Consultant",
        "MonthStart":'Jan',
        "YearStart":'2022',
        "MonthOfLeaving":"Mar",
        "YearOfLeaving":"2022",
        "Achievements":"Team Lead for a seven member team handling a major fortune 100 pharmacy retail client"
      },
      {
        "CompanyName":"",
        "specialization":"Jr Data Consultant",
        "MonthStart":'May',
        "YearStart":'2018',
        "MonthOfLeaving":"Dec",
        "YearOfLeaving":"2021",
        "Achievements":"Responsible for various data solutions such as predictive models, dashboards and ETL pipelines for multiple clients across retail and financial services sector"
      }
    ],
    "skillsDescription":"",
    "skills":[
      {
        "skillname":"Python"
      },
      {
        "skillname":"SQL"
      },
      {
        "skillname":"Tableau"
      }
      ,
      {
        "skillname":"PySpark"
      },
      {
        "skillname":"ReactJS"
      }
    ],
    "portfolio":[
      {
        "name":"CoWin Email Notification system",
        "description":"Developed an email notification system on COVID 19 vaccines by leveraging the API released by Govt of India",
        "imgurl":"https://github.com/rahulmr96"
      },
      {
        "name":"Austin gentrification prediction using Airbnb",
        "description":"Predictive model to identify factors that affect Airbnb prices. Also analyzed the likelihood of gentrification using airbnb with additional data such as demographics",
        "imgurl":"https://www.google.com/"
      },
      {
        "name":"College student sentiment monitoring",
        "description":"Scrapped r/UTAustin subrredit and performed Natural Language Processing techniques such as LDA topic modelling and sentiment analysis to identify major issues faced by students",
        "imgurl":"https://www.google.com/"
      }

    ] 
  }
  export default resumeData